var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg05Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.2 13.2",
    style: {
      enableBackground: "new 0 0 16.2 13.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#788195;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.7,0.5c-0.3-0.3-0.6-0.4-0.9-0.4H1.5c-0.4,0-0.7,0.1-0.9,0.4c-0.3,0.3-0.4,0.6-0.4,1v10.3 c0,0.4,0.1,0.7,0.4,1c0.3,0.3,0.6,0.4,0.9,0.4h13.3c0.4,0,0.7-0.1,0.9-0.4c0.3-0.3,0.4-0.6,0.4-1V1.5C16.1,1.1,16,0.8,15.7,0.5z  M15.1,11.8c0,0.1,0,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.1H1.5c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2V6.6h13.9V11.8z  M15.1,3.4H1.2V1.5c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1h13.3c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2V3.4z M4.4,9.9 H2.3V11h2.1V9.9z M8.7,9.9H5.5V11h3.2V9.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg05Icon);
export default __webpack_public_path__ + "static/media/05-icon.09c9c89c17219995824df28daa95a672.svg";
export { ForwardRef as ReactComponent };